import React, { useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";

const PopupDeleteConfirmation = ({ open, onClose, data, isNoticeboard = true, onDelete= () => {} }) => {
    

    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle style={{ background: "#202020", fontFamily: "poppins-mid" }}>Delete Noticeboard Slide</DialogTitle>
            <DialogContent style={{ background: "#202020" }}>
                
                <Box sx={{display: 'flex', flexDirection:'column'}}>


                    <img src={data.mediaUrl} style={{width: "400px", aspectRatio: 16 / 9, borderRadius: "10px", marginBottom: "10px"}} />

                    <Typography style={{fontSize: "16px", marginBottom: "20px", fontFamily: "poppins-reg", width: "400px"}}>Are you sure you want to delete this noticeboard slide?</Typography>
                    <DialogActions>
                        <Button onClick={onClose} style={{ fontFamily: "poppins-reg", color: "#ffffff" }}>Cancel</Button>
                        <Button onClick={() => { onDelete(data) }} style={{ fontFamily: "poppins-reg", color: "red", border: "1.5px solid #ff220040" }} variant="none">Delete Now</Button>
                    </DialogActions>
                </Box>

                    
            </DialogContent>
        </Dialog>
    );
};

export default PopupDeleteConfirmation;
